import { FunctionalComponent, h, JSX } from "preact";
import style from "./style.scss";

const Checkbox = ({children, id, value, setValue}) =>
    (<div className={style['checkbox']}>
        <input type="checkbox"
               id={id}
               value={value}
               onChange={ev => setValue((ev.target as HTMLInputElement).checked)} />
        <label htmlFor={id}>{children}</label>
    </div>)

export default Checkbox
